import { Route } from '@angular/router';
import { AdminHomeLayoutComponent } from './layouts/admin-home-layout/admin-home-layout.component';
import { LoginHomeComponent } from './components/login-home/login-home.component';
import { MsalGuard } from '@azure/msal-angular';
import { featureFlagGuard } from '@web/csl-lib-services';

export const appRoutes: Route[] = [
  {
    path: '',
    component: LoginHomeComponent
  },
  {
    path: '',
    component: AdminHomeLayoutComponent,
    children: [
      {
        path: 'dashboard',
        canActivate: [MsalGuard],
        data: {
          breadcrumb: 'Admin Dashboard'
        },
        loadComponent: () => import('./components/dashboard/dashboard.component').then(m => m.DashboardComponent),
      },
      {
        path: 'hr-index',
        data: {
          breadcrumb: 'Health Records'
        },
        loadComponent: () => import('./components/health-records/health-records.component').then(m => m.HealthRecordsComponent),
      },
      {
        path: 'hr-tx',
        data: {
          breadcrumb: 'Health Record Owner Transfers'
        },
        loadComponent: () => import('./components/health-record-owner-transfers/health-record-owner-transfers.component').then(m => m.HealthRecordOwnerTransfersComponent),
      },
      {
        path: 'hr-lg',
        data: {
          breadcrumb: 'Health Record Legal Guardian Requests'
        },
        loadComponent: () => import('./components/health-record-legal-guardian-requests/health-record-legal-guardian-requests.component').then(m => m.HealthRecordLegalGuardianRequestsComponent),
      },
      {
        path: 'users',
        data: {
          breadcrumb: 'Users'
        },
        loadComponent: () => import('./components/users/users.component').then(m => m.UsersComponent),
      },
      {
        path: 'clinics',
        data: {
          breadcrumb: 'Clinics'
        },
        loadComponent: () => import('./components/clinics/clinics.component').then(m => m.ClinicsComponent),
      },
      {
        path: 'reports',
        data: {
          breadcrumb: 'Reports'
        },
        loadComponent: () => import('./components/reports/reports.component').then(m => m.ReportsComponent),
      },
      {
        path: 'pfc-sessions',
        canActivate: [MsalGuard, featureFlagGuard('pfc_integration', '/dashboard')],
        data: {
          breadcrumb: 'Passport for Care'
        },
        loadComponent: () => import('./components/admin-pfc-sessions/admin-pfc-sessions.component').then(m => m.AdminPfcSessionsComponent),
      }

    ]
  }
];
